module.exports = __webpack_public_path__ + "static/media/24.87cf30f9.jpg";